import {useController} from 'react-hook-form';

import {TestIdProps} from 'shared/web';

import {FeaturesCheckboxTree} from '../../../components/FeaturesCheckboxTree/FeaturesCheckboxTree';
import {useCatalogue} from '../../../hooks/useCatalogue';
import {useCreatePageContext} from './CreatePageContext';

export function AllFeaturesFiled(props: TestIdProps) {
  const {control} = useCreatePageContext();
  const {field} = useController({
    name: 'features',
    control,
  });
  const {features} = useCatalogue();

  return (
    <FeaturesCheckboxTree
      value={field.value ?? null}
      onChange={(value) => {
        field.onChange(value);
        control.onChange();
      }}
      features={features}
      {...props}
    />
  );
}
